import React from 'react'

const adminSidebarApi ={
    topPart:{
        img:"./assets/images/dashboards/adminDashboard/sidebar/BSSmediumlogo.png"
    },
    
    menuItem: [
        {
            name:"HR",
            link:"",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"HR Dashboard",
                    link:"/admin/HRDashboard"
                },
                {
                    item:"Todays Attendance",
                    link:"/admin/HRTodaysAttendance"
                },
                {
                    item:"Employee Attendance",
                    link:"/admin/HREmployeeAttendance"
                },
                {
                    item:"Employee Salary",
                    link:"/admin/HREmployeeSalary"
                },
                {
                    item:"Job Management",
                    link:"/admin/HRJobManagement"
                },
                {
                    item:"Manage Candidates",
                    link:"/admin/HRManageCanditates"
                },
                {
                    item:"Policies",
                    link:"/admin/HRPolicies"
                },
               
               
               
            ],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        ,{
            name:"Home",
            link:"/admindashboard",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:true,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        ,{
            name:"Flex Value",
            link:"/flexvalueadashpage",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
       
        {
            name:"Bill",
            link:"/",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"Bill Entry",
                    link:"/admin/billentry"
                },
                {
                    item:"Bill Update",
                    link:"/admin/billupdate"
                },
                {
                    item:"Bill Cancel",
                    link:"/admin/billcancel"
                },
                {
                    item:"Bill Info",
                    link:"/admin/billinfo"
                },
            ]
        },
        {
            name:"Student Entry",
            link:"/",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"New Admission Entry",
                    link:"/admin/newadmissionentry"
                },
                {
                    item:"Student Entry Main",
                    link:"/admin/studententrymain"
                }
            ]
        },
        {
            name:"Employee Entry",
            link:"/admin/employeeEntryMain",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
            ],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Result",
            link:"/AdminResult",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                
            ]
        },
        {
            name:"Manage Online Admission",
            link:"/manageonlineadmission",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                
            ],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Attendance Summary",
            link:"/attendancesummary",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                
            ],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
       
        },
        {
            name:"Role",
            link:"",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:true,
            drpdwn:[
                {
                    item:"Role",
                    link:"/admin/role",
                    active:"Role",
                },
                {
                    item:"Role Management",
                    link:"/admin/rolemgmt",
                    active:"Role",
                },
            ]
        },
        {
            name:"Menus",
            link:"",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"Menu",
                    link:"/admin/menu"
                },
                {
                    item:"Menu Management",
                    link:"/admin/menumanagement"
                },
            ]
        },
        {
            name:"Result",
            link:"",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"Result Process",
                    link:"/admin/resultprocess"
                },
                {
                    item:"Report Card",
                    link:"/admin/reportcard"
                },
                {
                    item:"Student Position Process",
                    link:"/admin/stuposition"
                },
                {
                    item:"Result Report",
                    link:"/admin/resultreport"
                },
            ]
        },
        {
            name:"Attendance",
            link:"",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"Employee Wise Attendance",
                    link:"/admin/employeewiseatt"
                },
                
                {
                    item:"Student Attendance Process",
                    link:"/admin/studentattendanceprocess"
                },
                {
                    item:"Campus Wise Attendance",
                    link:"/admin/campuswiseatt"
                },
                {
                    item:"Campus Wise Student Attendance",
                    link:"/admin/campuswisestuatt"
                },

                {
                    item:"Emplouyee Attendance Report",
                    link:"/admin/empattenreport"
                },
                
            ]
        },
        {
            name:"Class Section Entry",
            link:"/admin/classsectionentry",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Setting",
            link:"/admin/setting",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"View Document",
            link:"/admin/viewdocument",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Validate Transaction",
            link:"/admin/validatetransaction",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Send Student Credentials",
            link:"/admin/sendstucredentials",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
       

        {
            name:"Class Teacher Assignment",
            link:"/admin/classteacherassignment",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Assessment Print",
            link:"/admin/assessmentprint",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Pre O Level O Level",
            link:"",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"Student Subject",
                    link:"/admin/preostudentsubject"
                },
                {
                    item:"Assign Teacher For Subjects",
                    link:"/admin/preoassignteacher"
                },
                {
                    item:"Setup Monthly Student Teacher",
                    link:"/admin/preosetupmonthlysutea"
                },
                {
                    item:"Update Monthly Student Subject & Teacher",
                    link:"/admin/preoupdatemonthlystutea"
                },
               
               
            ],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Shift",
            link:"",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"Attendance Report",
                    link:"/admin/attendanceReport"
                },
                {
                    item:"Attendance Policy",
                    link:"/admin/attendancepolicy"
                },
                {
                    item:"Leave Setup",
                    link:"/admin/leavesetup"
                },
                {
                    item:"HR Shift Setup",
                    link:"/admin/hrshiftsetup"
                },
                {
                    item:"Shift Assign",
                    link:"/admin/shiftassign"
                },
                {
                    item:"Exceptional Shift Assign",
                    link:"/admin/exshiftassign"
                },
                {
                    item:"Approve Attendance",
                    link:"/admin/approveattendance"
                },
               
            ],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Data Entry",
            link:"",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:true,
            drpdwn:[
                {
                    item:"Admit Card",
                    link:"/admin/admitcard"
                },
                {
                    item:"Session Entry",
                    link:"/admin/sessionentry"
                },
                {
                    item:"Period Entry",
                    link:"/admin/periodentry"
                },
                {
                    item:"Routine Entry",
                    link:"/admin/routineEntry"
                },
                {
                    item:"Campus",
                    link:"/admin/campus"
                },
                {
                    item:"Subject Wise Assessment Mark",
                    link:"/admin/subwiseassessment"
                },
                {
                    item:"Class Subject",
                    link:"/admin/classSubject"
                },
                {
                    item:"Student Subject",
                    link:"/admin/studentsubject"
                },
                {
                    item:"Class Subject For Admin",
                    link:"/admin/classSubjectForAdmin"
                },
                {
                    item:"Subject Subgroup",
                    link:"/admin/subjectSubgroup"
                },
                {
                    item:"General Info",
                    link:"/admin/generalInfo"
                },
                {
                    item:"Subject",
                    link:"/admin/subject"
                },
                {
                    item:"Notice",
                    link:"/admin/noticeadmin"
                },
                {
                    item:"News",
                    link:"/admin/news"
                },
                {
                    item:"Class Routine",
                    link:"/admin/classRoutine"
                },
                {
                    item:"Documents",
                    link:"/admin/documents"
                },
                
               
            ],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },

    
    
    ]
}

const AdminSidebar = () => {
  return (
    <>
    
    </>
  )
}

export {adminSidebarApi}

export default AdminSidebar